import { Xmark } from 'iconoir-react';
import { TooltipButton } from '@listening/frontend/components/custom/tooltip-button';
import { cn } from '@listening/utils/react-helpers';
import * as m from '@/paraglide/messages';
import { DocumentAiContent, useDocumentInsights } from './document-ai-sidebar';
import { useReadAlongSidebarStore } from './read-along-store';

export function DocumentInsightsSidebar({ className }: { className?: string }) {
  const { sidebarState, setSidebarState } = useReadAlongSidebarStore();
  const insights = useDocumentInsights();
  const open = sidebarState === 'information' && !!insights?.opened;
  return (
    <aside
      aria-label={m.read_along_ai_title()}
      aria-hidden={!open}
      inert={!open}
      className={cn(
        'absolute inset-y-0 right-0 z-5 flex min-w-0 flex-col overflow-hidden bg-[var(--v2-page-bg)] transition-[width,visibility] duration-350 ease-out motion-reduce:transition-none sm:relative sm:shrink-0',
        open
          ? 'visible w-full border-l border-border sm:w-[22.75rem]'
          : 'invisible w-0',
        className,
      )}
    >
      <div
        className={cn(
          'relative flex h-full min-h-0 w-full min-w-[min(100vw,22.75rem)] flex-col transition-[opacity,transform] duration-350 ease-out motion-reduce:transition-none sm:w-[22.75rem]',
          open ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0',
        )}
      >
        <TooltipButton
          aria-label={m.common_close()}
          toolTipContent={m.common_close()}
          variant='ghost'
          size='icon'
          className='absolute top-3 right-3 z-10 size-8 rounded-full bg-[var(--v2-card-bg)] text-[var(--v2-text-muted)] transition-colors hover:text-[var(--v2-text-primary)]'
          onClick={() => setSidebarState('closed')}
        >
          <Xmark aria-hidden className='size-4' />
        </TooltipButton>
        {open && <DocumentAiContent />}
      </div>
    </aside>
  );
}
